<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆系统</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>场馆服务用户登记表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="登记手机号码：">
              <el-input
                size="small"
                v-model="listParams.vipMobile"
                placeholder="请输入登记手机号码"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData">
                查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button
            class="align-left"
            type="primary"
            size="small"
            @click="toCreate"
          >
            新增
          </el-button>

          <form enctype="multipart/form-data">
            <el-upload
              ref="upload"
              class="upload-btn mgl20"
              accept="file"
              :show-file-list="false"
              :action="uploadAction"
              :data="uploadParams"
              :before-upload="beforeUpload"
              :on-success="successCallback"
              :on-error="errorCallback"
            >
              <el-button size="small" type="success">上传</el-button>
            </el-upload>
          </form>
          <!--<form enctype="multipart/form-data">-->
          <!--<input type="file" id="importBtn" @change="importExcel">-->
          <!--</form>-->

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="userAccount" align="center" label="用户账号">
        </el-table-column>

        <el-table-column prop="vipMobile" align="center" label="登记手机号">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要删除该条数据？"
              @confirmed="deleteItem(scope.row.id)"
            >
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog
      class="hx-to-create-template"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      @close="resetDialogForm"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          v-loading="dialogLoading"
          ref="dialogForm"
          :model="itemParams"
          :rules="checkItemParams"
          label-width="150px"
        >
          <el-form-item label="用户账号：" prop="userAccount">
            <el-input
              v-model="itemParams.userAccount"
              size="small"
              placeholder="请输入用户账号"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="场馆服务手机号：" prop="vipMobile">
            <el-input
              v-model="itemParams.vipMobile"
              size="small"
              placeholder="请输入场馆服务手机号"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              :disabled="isDisabled"
              size="small"
              type="primary"
              @click="saveItem('dialogForm')"
            >
              保 存
            </el-button>

            <el-button size="small" @click="dialogVisible = false">
              取 消
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        vipMobile: "",
        stadiumType: "",
        stadiumId: ""
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      supplyCentreList: [],
      dialogTitle: "",
      dialogVisible: false,
      method: "",
      url: "",
      isDisabled: false,
      dialogLoading: false,
      itemParams: {
        userAccount: "",
        vipMobile: "",
        stadiumType: "",
        stadiumId: ""
      },
      checkItemParams: {
        userAccount: [
          { required: true, message: "请输入用户账号", trigger: "blur" }
        ],
        vipMobile: [
          { required: true, message: "请输入登记手机号", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    uploadAction() {
      return global.apiUrl + "/stadium/user/import";
    },
    uploadParams() {
      return {};
    }
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = this.commonBodyParams(this.listParams, this.pager);
      bodyParams.stadiumType = parseInt(this.$route.params.stadiumType);
      bodyParams.stadiumId = parseInt(this.$route.params.stadiumId);
      this.$http({
        url: global.apiUrl + "/stadium/user/list",
        method: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;

          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增场馆服务用户登记表
     */
    toCreate() {
      this.itemParams.userAccount = "";
      this.itemParams.vipMobile = "";
      this.dialogVisible = true;
      this.dialogTitle = "新增场馆服务用户登记表";
      this.method = "POST";
      this.url = "/stadium/user/add";
      if (this.itemParams.id) {
        delete this.itemParams.id;
      }
    },
    /**
     * 上传前的操作
     * @param file
     */
    beforeUpload(file) {
      const Xls = file.name.split(".");
      if (Xls[1] === "xls" || Xls[1] === "xlsx") {
        return true;
      } else {
        this.$message.error("上传文件只能是 xls/xlsx 格式!");
        return false;
      }
    },
    /**
     * 成功回调
     * @param res
     * @param file
     * @param fileList
     */
    successCallback(res, file, fileList) {
      if (res.apiStatus === 0 && res.sysStatus === 0) {
        this.$message.success(res.info);
        this.loadTableData();
      } else {
        this.$message.error(res.info);
      }
    },
    /**
     * 错误回调
     * @param err
     * @param file
     * @param fileList
     */
    errorCallback(err, file, fileList) {
      this.$message.error(err);
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 保存新增或修改
     */
    saveItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign({}, this.itemParams);
          bodyParams.stadiumType = parseInt(this.$route.params.stadiumType);
          bodyParams.stadiumId = parseInt(this.$route.params.stadiumId);
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: bodyParams
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.dialogVisible = false;
                this.isDisabled = false;
                this.loadTableData();
              } else {

                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 修改条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑场馆服务用户登记表";
      this.itemParams = Object.assign({}, row);
      this.dialogVisible = true;
      this.method = "PUT";
      this.url = "/stadium/user/save";
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/stadium/user/delete?id=" + id,
        method: "DELETE"
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {

          }
        })
        .catch(err => {

          console.error(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
